import React, { Component } from 'react';

import { Checkbox } from 'antd';
import { Link } from "react-router-dom";

import Api from '../../api/Api';

import Main from '../../components/Main';

class NDAPage extends Component { 
    constructor(props) {
        super();
        this.state = {
            main_heading: '',
            main_content: ''
        }
    }

    componentDidMount = () => {

        var account_token = localStorage.getItem('account_token');
        this.setState({account_token: account_token});

        this.loadData();
    }

    render () {

        return (

            <Main page_title="NDA Page" hide_page_title="true">
                <div className="inner-page white-bg">
                    <div className="container">
                        <div className="heading text-center">{this.state.main_heading}</div>
                        <div className="content">
                            <div dangerouslySetInnerHTML={{ __html: this.state.main_content }} />

                            <Checkbox className="orng">I agree to the <Link to="" className="c-o">NDA (Non-Disclosure Agreement)</Link>.</Checkbox>

                        </div>
                    </div>
                </div>
            </Main>
        )
    }


    loadData = () => {

        const formData = new FormData();
        var that = this;

        Api.post('cms/nda', formData, function(data){
            
            that.setState({
                main_heading: data.main_heading,
                main_content: data.main_content
            });
        });
    }
}

export default NDAPage;